import { getEnv } from '@/libs/Environment.js'

export default {
    state: {
        homeMenu: {
            isVisible: false,
            itens: [
                {
                    name: 'Perfil',
                    icon: 'fas fa-user',
                    action: '/profile',
                    show: true
                },
                {
                    name: 'Alterar Senha',
                    icon: 'fas fa-key',
                    action: '/updatePassword',
                    show: true,
                    permission: 'TROCASENHA'
                },
                {
                    name: 'Recarregar Cartão',
                    icon: 'fas fa-refresh',
                    action: '/cardRecharge',
                    show: true,
                    permission: 'RECARREGACARTAO'
                },
                {
                    name: 'Fale Conosco',
                    icon: 'fa-solid fa-headset',
                    action: '/contactUs',
                    show: true,
                    permission: 'FALECONOSCO'
                },
                {
                    name: 'Precisa de ajuda?',
                    icon: 'fa-solid fa-question',
                    action: '/help',
                    external: true,
                    show: true
                }
            ],
            footerItens: [
                {
                    name: 'Sair',
                    icon: 'fa-solid fa-sign-out',
                    action: 'logOut'
                }
            ]
        },
        login: {
            controlsEnabled: true,
            isLoading: false,
            formData: [
                {
                    display: 'Escolha a instituição',
                    required: true,
                    isVisible: getEnv().usa_instituicao_cliente_filial === 'N',
                    type: 'select'
                },
                {
                    placeHolder: 'Digite seu login',
                    display: 'Login (CPF, Matrícula, Nome de usuário)',
                    required: true,
                    type: 'text',
                    isVisible: true
                },
                {
                    placeHolder: 'Digite sua senha (Senha padrão: 123)',
                    display: 'Senha',
                    required: true,
                    type: 'password',
                    isVisible: true
                },
                {
                    display: 'Lembrar senha',
                    type: 'checkbox',
                    isVisible: true
                }
            ],
            buttons: [
                {
                    display: 'Entrar',
                    fill: true,
                    action: 'login',
                    disabled: false,
                    show: false
                },
                {
                    icon: 'key',
                    display: 'Esqueci minha senha',
                    action: 'changeRecoverPasswordMenuVisibility',
                    disabled: false,
                    show: false
                },
                {
                    display: 'Cadastrar',
                    action: 'register',
                    disabled: false,
                    show: false
                },
                {
                    display: 'Precisa de ajuda?',
                    action: 'help',
                    disabled: false,
                    show: false
                }
            ]
        },
        menuList: [
            {
                icon: 'fa-regular fa-money-bill',
                display: 'Saldo',
                visControl: null,
                action: '/fullBalance',
                permission: 'CONSULTASALDO'
            },
            {
                icon: 'fas fa-credit-card',
                display: 'Recarregar Saldo',
                permission: 'RECARREGACARTAO',
                visControl: 'RECARREGACARTAO',
                action: '/cardRecharge'
            },
            {
                icon: 'fas fa-address-card',
                display: 'Meus Cartões',
                visControl: null,
                action: '/myCards'
            },
            {
                icon: 'fa-solid fa-headset',
                display: 'Fale Conosco',
                visControl: null,
                action: '/contactUs',
                permission: 'FALECONOSCO'
            },
            {
                icon: 'fa-solid fa-utensils',
                display: 'Cardapio',
                visControl: 'VISUALIZACARDAPIO',
                action: '/menu',
                permission: 'VISUALIZACARDAPIO'
            }
        ],
        recoverPasswordMenu: {
            isVisible: false
        },
        modalInfo: {
            isVisible: false,
            text: '',
            icon: '',
            buttons: [],
            types: {
                default: {
                    icon: 'fa-solid fa-check',
                    buttons: [
                        {
                            buttonText: 'Fechar',
                            buttonAction: 'closeModal'
                        }
                    ]
                },
                success: {
                    icon: 'fa-solid fa-check',
                    buttons: [
                        {
                            buttonText: 'Fechar',
                            buttonAction: 'closeModal'
                        }
                    ]
                },
                defaultDialog: {
                    icon: 'fa-solid fa-question',
                    buttons: [
                        {
                            buttonText: 'Sim',
                            buttonAction: 'actionTrue'
                        },
                        {
                            buttonText: 'Não',
                            buttonAction: 'actionFalse'
                        }
                    ]
                },
                error: {
                    icon: 'fa-solid fa-warning',
                    buttons: [
                        {
                            buttonText: 'Fechar',
                            buttonAction: ''
                        }
                    ]
                }
            }
        },
        selectList: {
            isVisible: false,
            title: '',
            optionDisplay: '',
            options: [],
            event: ''
        },
        deleteItemMenu: {
            isVisible: false
        },
        baseInfo: {
            CDCLIENTE: '',
            CDFILIAL: '',
            NMFANTCLIE: ''
        },
        password: {
            DEFAULT: false
        },
        isOnline: true,
        baseInfoList: []
    },
    mutations: {
        setHomeMenuVisibility (state) {
            state.homeMenu.isVisible = !state.homeMenu.isVisible
        },
        setRecoverPasswordMenuVisibility (state) {
            state.recoverPasswordMenu.isVisible = !state.recoverPasswordMenu.isVisible
        },
        showModalInfo (state, data) {
            const type = data.type || 'default'
            state.modalInfo.text = data.text
            state.modalInfo.icon = data.icon || state.modalInfo.types[type].icon
            state.modalInfo.buttons = data.buttons || state.modalInfo.types[type].buttons

            if (data.open) {
                state.modalInfo.isVisible = true
            }
        },
        closeModalInfo (state) {
            state.modalInfo.isVisible = false
        },
        showSelectList (state, data) {
            state.selectList.title = data.title
            state.selectList.options = data.options
            state.selectList.optionDisplay = data.optionDisplay
            state.selectList.event = data.event
            state.selectList.isVisible = true
        },
        closeSelectList (state) {
            state.selectList.title = ''
            state.selectList.options = []
            state.selectList.optionDisplay = ''
            state.selectList.event = ''
            state.selectList.isVisible = false
        },
        setDeleteItemMenuVisibility (state) {
            state.deleteItemMenu.isVisible = !state.deleteItemMenu.isVisible
        },
        setBaseInfo (state, data) {
            state.baseInfo.CDCLIENTE = data.CDCLIENTE
            state.baseInfo.CDFILIAL = data.CDFILIAL
            state.baseInfo.NMFANTCLIE = data.NMFANTCLIE
        },
        setBaseInfoList (state, data) {
            state.baseInfoList = data
        },
        setDefaultPasswordWarning (state, data) {
            state.password.DEFAULT = data
        },
        setLoginControlsEnabled (state, data) {
            state.login.controlsEnabled = data
        },
        resetLoginState (state) {
            state.login.formData[0].value = null
            state.login.formData[1].value = null
            state.login.formData[2].value = null
            state.login.formData[3].value = true
        },
        setShowRegisterButton (state, data) {
            state.login.buttons[2].show = data
        },
        setOnlineStatus (state, data) {
            state.isOnline = data
        },
        startLoadingLogin (state) {
            state.login.isLoading = true
        },
        stopLoadingLogin (state) {
            state.login.isLoading = false
        }
    },
    actions: {
        changeHomeMenuVisibility ({ commit }) {
            commit('setHomeMenuVisibility')
        },
        changeRecoverPasswordMenuVisibility ({ commit }) {
            commit('setRecoverPasswordMenuVisibility')
        },
        showModalInfo ({ commit }, data) {
            commit('showModalInfo', data)
        },
        closeModalInfo ({ commit }) {
            commit('closeModalInfo')
        },
        showSelectList ({ commit }, data) {
            commit('showSelectList', data)
        },
        closeSelectList ({ commit }) {
            commit('closeSelectList')
        },
        changeDeleteItemVisibility ({ commit }) {
            commit('setDeleteItemMenuVisibility')
        },
        setBaseInfo ({ commit }, data) {
            commit('setBaseInfo', data)
        },
        setBaseInfoList ({ commit }, data) {
            commit('setBaseInfoList', data)
        },
        setDefaultPasswordWarning ({ commit }, data) {
            commit('setDefaultPasswordWarning', data)
        },
        setLoginControlsEnabled ({ commit }, data) {
            commit('setLoginControlsEnabled', data)
        },
        resetLoginState ({ commit }) {
            commit('resetLoginState')
        },
        setShowRegisterButton ({ commit }, data) {
            commit('setShowRegisterButton', data)
        },
        setOnlineStatus ({ commit }, data) {
            commit('setOnlineStatus', data)
        },
        startLoadingLogin ({ commit }) {
            commit('startLoadingLogin')
        },
        stopLoadingLogin ({ commit }) {
            commit('stopLoadingLogin')
        }
    },
    getters: {
        homeMenuList: (state) => state.menuList,
        homeMenu: (state) => state.homeMenu,
        recoverPasswordMenu: (state) => state.recoverPasswordMenu,
        modalInfo: (state) => state.modalInfo,
        selectList: (state) => state.selectList,
        deleteItemMenu: (state) => state.deleteItemMenu,
        getBaseInfo: (state) => state.baseInfo,
        getBaseInfoList: (state) => state.baseInfoList,
        getDefaultPasswordWarning: (state) => state.password,
        getLoginFormData: (state) => state.login.formData,
        getLoginButtons: (state) => state.login.buttons,
        loginControlsEnabled: (state) => state.login.controlsEnabled,
        getOnlineStatus: (state) => state.isOnline,
        loginIsLoading: (state) => state.login.isLoading
    }
}
